import React from 'react'
import routes from '../../router/routes'
import { strings } from '../../../localization/strings'
import Loader from '../../loaders'
import { Button } from '@material-ui/core/index'
import { getEula, acceptEula } from '../../../helpers/restHelpers'

class Component extends React.Component {
    state = {
        loading: true,
    }

    handleAgree = () => {
        this.setState({ loading: true })
        acceptEula({ version: this.state.version })
            .then(() => this.props.history.push(routes.orders.path))
            .catch((error) => window.showDialog(error))
            .finally(() => this.setState({ loading: false }))
    }

    componentDidMount() {
        this.setState({ loading: true })
        getEula()
            .then((response) => this.setState({ ...response }))
            .catch((error) => window.showDialog(error))
            .finally(() => this.setState({ loading: false }))
    }

    render() {
        if (this.state.loading) return <Loader />

        return (
            <div
                style={{
                    padding: 20,
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <div dangerouslySetInnerHTML={{ __html: this.state.text }} />
                <br />
                <p style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>
                    <b>{strings.eulaAccepted}</b>
                </p>
                <Button
                    onClick={this.handleAgree}
                    variant="contained"
                    color="primary"
                    style={{ margin: '20px auto' }}
                >
                    {strings.agree}
                </Button>
            </div>
        )
    }
}

export default Component
